import React, {useEffect, useState} from "react";
import axiosInstance from "../../../api/api";
import {Spinner} from "@themesberg/react-bootstrap";
import {Button, Col, Form, Modal, Row, Table} from "react-bootstrap";
import TextWhitTooltip from "../Util/TextWhitTooltip";
import CurrencyInput from "../Util/CurrencyInput";

const PeuTable = ({ optionName, ciemId }) => {
    const [peuList, setpeuList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [tableHeaders, setTableHeaders] = useState([]);
    const [newpeu, setNewpeu] = useState({ descripcion: '', valor: '' });

    useEffect(() => {
        inicializar();
        fetchPeuList();
    }, []);

    const fetchPeuList = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('/peu/'+ciemId.ciemId); // <-- Ajusta esta ruta
            setpeuList(response.data.data);
            const tableHeader = await axiosInstance.get('/detailoption/option/value/'+optionName);
            setTableHeaders(tableHeader.data.data);
            console.log("tabla empleado")
            console.log(tableHeader)
        } catch (error) {
            console.error('Error al cargar:', error);
            alert('Error al cargar los datos');
        } finally {
            setLoading(false);
        }
    };

    const inicializar= async ()=>{
        try {
            await axiosInstance.post('/peu/inicializar/'+ciemId.ciemId); // <-- Ajusta esta ruta
            //setpeuList(response.data);
        } catch (error) {
            console.error('No se pudo inicializar:', error);
            alert('Error inicializando datos');
        } finally {
            setLoading(false);
        }
    }

    const handleValueChange = (name, value) => {
        const updatedList = peuList.map(c => {
            if (c.name === name) {
                return { ...c, valor: value }; // Retorna una copia actualizada
            }
            return c; // Retorna el original si no coincide
        });
        setpeuList(updatedList); // Actualiza el estado con la nueva lista
    };

    const handleSave = async () => {
        try {
            console.log(peuList)
            await axiosInstance.post('/peu/save', peuList); // <-- Ajusta esta ruta
            fetchPeuList();
            alert('Guardado correctamente');
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar los datos');
        }
    };

    const handleAddNew = async () => {
        if (!newpeu.descripcion.trim() || isNaN(parseFloat(newpeu.valor))) {
            alert('Debe ingresar un descripcion y un valor numérico válido');
            return;
        }

        try {
            const response = await axiosInstance.post('/peu/', {
                descripcion: newpeu.descripcion,
                name: newpeu.descripcion, // El backend puede manejar `name` igual a `descripcion` si se necesita
                valor: parseFloat(newpeu.valor),
                type: optionName,
                orden: peuList.length -3,
                ciem: ciemId.ciemId
            });
            setpeuList([...peuList, response.data]);
            setNewpeu({ descripcion: '', valor: '' });
            await handleSave();
            setShowModal(false);
        } catch (error) {
            console.error('Error al agregar nuevo:', error);
            alert('No se pudo agregar el nuevo descripcion');
        }
    };

    if (loading) return <Spinner animation="border" />;

    return (
        <>
            <Table bordered>
                <thead>
                <tr>
                    <th>descripcion</th>
                    <th>Valor</th>
                </tr>
                </thead>
                <tbody>
                {peuList // 1. ordenar por orden
                    .map((item, index) => {
                        // 2. buscar el peu correspondiente por name === value (ajusta si es otro campo)
                        const header = tableHeaders.find(c => c.value === item.name);
                        if (!header){
                            return (
                                <tr key={index}>
                                    <td>
                                        <span>{item.descripcion}</span>
                                    </td>
                                    <td>
                                        <Form.Control
                                            type='number'
                                            value={item.valor}
                                            name={item.name}
                                            onChange={(e) => handleValueChange(e.target.name, e.target.value)}
                                            readOnly={true}
                                        />
                                    </td>
                                </tr>
                            );
                        } // si no hay coincidencia, no renderizar// Suponemos orden correlativo
                        return (
                            <tr key={index}>
                                <td>
                                    <TextWhitTooltip value={item.descripcion} detail={header} />
                                </td>
                                <td>
                                    <CurrencyInput
                                        type={header.type === 'number' ? 'number' : 'text'}
                                        value={item.valor}
                                        name={item.name}
                                        onChange={(e) => handleValueChange(e.target.name, e.target.value)}
                                        readOnly={!header.editable}
                                        title={header.tooltip || ''}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>

            <Row className="mt-3">
                <Col className="text-end">
                    <Button variant="primary" onClick={handleSave}>Actualizar</Button>
                </Col>
            </Row>


        </>
    );
};

export default PeuTable;